<template>
  <page-wrapper background="/static/img/anniversary/page-contract-first/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
      <span class="text-highline">{{data.firstContractDate}}</span><br />
      是您第一个合同的签订日<br />
      您购买的产品为<span class="text-highline">{{data.firstContractProduct}}</span><br />
      <div v-if="data.firstContractTLNo">
        当年共有<span class="text-highline">{{data.firstContractTLBuyers}}</span>
        与您选择了相同的载体
        <br/>
        科研道路上您并不孤单
      </div>
      <div v-else>
        成交只是起点，服务没有终点
      </div>
    </div>
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-text {
    position: absolute;

    left: 50%;
    top: 6.933333333vw;
    margin-left: -40.65vw;
    width: 81.3vw;
    height: 28vw;
    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    letter-spacing: -0.3px;
    z-index: 99;

    /* 字体 */
    color: #193543;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }

    .text-notice {
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?dd717bb2